// src/actions/checkout/placeorderActions.js
import { afterplaceOrderApi } from "../../api/checkout/afterplaceOrderApi";
import { AFTER_PLACEORDER_SUCCESS, AFTER_PLACEORDER_FAILURE, AFTER_CLEAR_PLACEORDER } from "../types";

export const afterPlaceOrderSuccess = (placeorder) => ({
  type: AFTER_PLACEORDER_SUCCESS,
  payload: placeorder,
});

export const afterPlaceOrderFailure = (error) => ({
  type: AFTER_PLACEORDER_FAILURE,
  payload: error,
});

export const clearafterPlaceOrder = (error) => ({
  type: AFTER_CLEAR_PLACEORDER,
});

export const afterPlaceOrder = (postData) => {
  return (dispatch) => {
    afterplaceOrderApi(postData)
      .then((response) => {
        dispatch(afterPlaceOrderSuccess(response.data));
      })
      .catch((error) => {
        console.log("error");
        console.log(error);
        dispatch(afterPlaceOrderFailure(error.message));
      });
  };
};
